<template>
    <div class="autocomplete-search pin-edit-series-search">
        <div class="input-group w-100">
            <vue-autosuggest
                v-model="query"
                :suggestions="searchSuggestions"
                @focus="focusMe"
                @click="clickHandler"
                @input="onInputChange"
                @selected="onSelected"
                :get-suggestion-value="getSuggestionValue"
                component-attr-id-autosuggest="autosuggest__series"
                :input-props="{
                id:'autosuggest__series__input',
                class:'form-control shadow-none data-hj-allow',
                placeholder:placeholder
            }">
                <div slot-scope="{suggestion}" class="d-flex">
                    <div v-if="!suggestion.item.id">
                        {{suggestion.item.title}}
                        <small v-if="context === 'pin-edit'" class="text-muted">(create new)</small>
                        <small v-else class="text-muted">(rename)</small>
                    </div>
                    <div v-else>{{suggestion.item.title}}</div>
                </div>
            </vue-autosuggest>
            <button @click="clearSearch" type="button" class="btn bg-transparent" style="margin-left: -40px; z-index: 100;">
                <i class="fa-regular fa-xmark text-muted"></i>
            </button>
        </div>
        <input type="hidden" name="selected_id" :value="selected.id">
        <input type="hidden" name="series" :value="query">
    </div>
</template>

<script>
    import { VueAutosuggest } from 'vue-autosuggest';
    export default {
        components: {
            VueAutosuggest
        },
        name: "SeriesSearch",
        props: ['old', 'default', 'placeholder', 'context'],
        data: function () {
            return {
                query: this.default,
                selected: false,
                searchSuggestions: [ { data: null } ],
            }
        },
        computed: {
            //
        },
        created() {
            if (this.old) {
                this.query = this.old;
            }
        },
        methods: {
            onInputChange: function(text) {
                // event fired when the input changes
                let q = text.trimStart().replace(/\s\s+/g, ' ');
                this.query = q;

                if (q !== '') {
                    axios.get('/search', {
                        params: {
                            q: q,
                            searching: 'series'
                        }
                    }).then(response => {
                        this.searchSuggestions[0].data = response.data;
                    });
                } else {
                    this.searchSuggestions[0].data = null;
                }
            },
            onSelected: function(item) {
                if (item && item.item.id) {
                    this.selected = item.item;
                    this.query = item.item.name;
                    VueEvent.$emit('selectedSearchedSeries', item.item);
                } else {
                    // Empty search
                    this.selected = false;
                }
            },
            clearSearch: function() {
                this.query = '';
                this.searchSuggestions[0].data = null;
                this.selected = false;
            },
            clickHandler: function(item) {
                // event fired when clicking on the input
            },
            /**
             * This is what the <input/> value is set to when you are selecting a suggestion.
             */
            getSuggestionValue(suggestion) {
                return suggestion.item.name;
            },
            focusMe(e) {
                // FocusEvent
            }
        }
    }
</script>
